import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/hasOverlaps/${number | ':timeSheetId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/hasOverlaps/:timeSheetId`;

export const URL = (timeSheetId: number): RouteDefinition =>
	`${baseRoute}/hasOverlaps/${timeSheetId}`;
